import { PMTCFv2InlineSettings, PMTCFv2InlineTypes } from "../PMTCFv2Inline/PMTCFv2InlineSettings";

export class PMTCFv2InlineNeutralSettings {
  constructor(c = {}) {
    const settings = {
      ...new PMTCFv2InlineSettings(c),
      neutralButtonBackgroundColor: 'gray',
      neutralButtonFontColor: 'white',

      onButtonBackgroundColor: 'green',
      onButtonFontColor: 'white',
      onButtonText: 'Accept',

      offButtonBackgroundColor: 'red',
      offButtonFontColor: 'white',
      offButtonText: 'Reject',

      requiredConsentText: "Required For Consent",
      requiredConsentLetter: "R",
    }

    Object.assign(this, settings, c)
  }
}

export const PMTCFv2InlineNeutralTypes = {
  ...PMTCFv2InlineTypes,
  'toggle settings': {
    neutralButtonBackgroundColor: { title: 'Neutral Button Background Color', type: 'ColorPicker' },
    neutralButtonFontColor: { title: 'Neutral Button Font Color', type: 'ColorPicker' },

    onButtonBackgroundColor: { title: 'On Button Background Color', type: 'ColorPicker' },
    onButtonFontColor: { title: 'ON Button Font Color', type: 'ColorPicker' },
    onButtonText: { title: 'ON Button Text', type: 'InputLanguage' },

    offButtonBackgroundColor: { title: 'Off Button Background Color', type: 'ColorPicker' },
    offButtonFontColor: { title: 'Off Button Font Color', type: 'ColorPicker' },
    offButtonText: { title: 'Off Button Text!', type: 'InputLanguage' },

    requiredConsentText: { title: 'Required Consent Tag Text', type: 'InputLanguage' },
  },

  'purpose content': {
    ...PMTCFv2InlineTypes['purpose content'],

    requiredConsentText: { title: 'Required Consent', type: 'InputLanguage' },
    requiredConsentLetter: { title: 'Custom Icon', type: 'InputLanguage' },
  }
}